<div class="pointer-events-none relative inline select-none" [style.width.px]="size()" [style.height.px]="size()">
  <!-- left jaw -->
  <div
    class="absolute origin-top -translate-x-[100%] -translate-y-[80%] transition-transform"
    [ngStyle]="{
      transform: opened() ? 'rotate(25deg)' : 'rotate(-1deg)',
      width: 9.5 * size() + 'px',
    }"
  >
    <img [src]="spritePath + 'claw-left.png'" />
  </div>
</div>
